/* eslint-disable react/prop-types */
import { inject, observer } from "mobx-react";
import { Preloader, RmBodyZone } from "randmarcomps";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RmPageHeader from "../components/layout/RmPageHeader";
import { RootStore } from "../stores/rootStore";
import { manager } from "../stores/user/UserStore";

interface IProps {
  store?: RootStore;
}

const SignInRedirect: React.FC<IProps> = ({ store }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSigninCallback = async () => {
      try {
        const user = await manager.signinRedirectCallback();
        await store!.userStore.storeUser(user);
        if (!user.state || user.state === "/") {
          const rawApplicationId = (user.profile as Record<string, unknown>)["ApplicationId"];
          const applicationId =
            typeof rawApplicationId === "string"
              ? rawApplicationId
              : typeof rawApplicationId === "number"
                ? String(rawApplicationId)
                : "";
          navigate("/" + applicationId);
        } else {
          navigate(user.state as string);
        }
      } catch (error) {
        console.error("Sign-in redirect failed:", error);
      }
    };

    handleSigninCallback();
  }, [navigate, store]);

  return (
    <>
      <RmPageHeader
        title="Signing In"
        subtitle="Completing secure authentication and redirecting to your portal."
      />
      <RmBodyZone className="pb-10">
        <Preloader
          className="fixed inset-0 bg-primary"
          color="white"
          text="Signing in..."
        />
      </RmBodyZone>
    </>
  );
};

export default inject("store")(observer(SignInRedirect));
